import React from 'react';
import { IComponentPhoto } from '../../component';

export default function useGalleryListWrapper(data?: any, types?: string[]) {
  const { pageDetail } = window;
  let { template } = pageDetail;

  types = types || [`photo`];

  if (data) {
    template = data;
  }

  const component = (template || []).find(
    one => types.indexOf(one.type) > -1
  ) as any | null;
  return component;
}
